
import { Map } from '../store/application/models/map/map'
import { IAxiosResponse} from '../store/ducks/root.types'
import axiosInstance from './axios'

class RelevanceService {

  constructor(private apiVersion: string = 'v1') {}
  /**
   * 
   * 
   * @returns 
   */
  public async getAll(): Promise<IAxiosResponse<Map[]>> {
 
    return axiosInstance
      .get(`${this.apiVersion}/municipalities/report`)
      .then((response) => {
        return {
          data: response.data.map((data: any) => new Map().fromJSON(data)),
          headers: response.headers
        }
      })
  }
}
const relevanceService = new RelevanceService()

export default relevanceService